import { apiClient } from '@/api/api'
import type { LookConfig, LookSubmitResult, TinderCardItem } from '../types/look-config'

export interface LookSubmitRequest {
  lookConfigId: string
  answers: Record<string, any>
  metadata?: {
    completedAt?: string
    deviceType?: string
    language?: string
  }
}

/**
 * The legacy look flow. The profile no longer opens it (the event outfit is the capsule
 * survey, 2026-10-12); `GET /look/config` has no backend route, so this rejects — no mock
 * stands in for it any more.
 */
export async function fetchLookConfig(): Promise<LookConfig> {
  const response = await apiClient.get<LookConfig>('/look/config')
  return response.data
}

export async function submitLookAnswers(data: LookSubmitRequest): Promise<LookSubmitResult> {
  try {
    const response = await apiClient.post<LookSubmitResult>('/look/submit', data)
    return response.data
  } catch (error) {
    console.error('Error submitting look answers:', error)
    throw error
  }
}

export interface FetchNextLookCardParams {
  lookConfigId: string
  currentCardIndex: number
  limit: number
}

export async function fetchNextLookCard(params: FetchNextLookCardParams): Promise<TinderCardItem[]> {
  const { lookConfigId, currentCardIndex, limit } = params
  const queryParams = new URLSearchParams({
    lookConfigId,
    currentCardIndex: currentCardIndex.toString(),
    limit: limit.toString()
  })
  const response = await apiClient.get<TinderCardItem[]>(`/look/cards/next?${queryParams.toString()}`)
  return response.data
}

export interface SubmitLookCardActionParams {
  lookConfigId: string
  cardId: string
  action: 'like' | 'dislike'
}

export async function submitLookCardAction(params: SubmitLookCardActionParams): Promise<void> {
  const { lookConfigId, cardId, action } = params
  const maxRetries = 3
  const retryDelay = 1000 // 1 секунда

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      await apiClient.post(`/look/cards/${cardId}/like`, {
        lookConfigId,
        cardId,
        action
      })
      return
    } catch (error: any) {
      if (attempt === 1) {
        console.warn('Failed to submit look card action to backend, retrying...', error)
      }

      console.error(`Error submitting look card action (attempt ${attempt}/${maxRetries}):`, error)

      if (attempt === maxRetries) {
        throw new Error(`Не удалось отправить действие. Пожалуйста, попробуйте еще раз.`)
      }

      await new Promise(resolve => setTimeout(resolve, retryDelay * attempt))
    }
  }
}

